// extracted by mini-css-extract-plugin
export default {"body":"Entradas_body__Srm4O","content":"Entradas_content__A41-C","menuGroup":"Entradas_menuGroup__DdJYg"};